////////////////////////////////////////////////////////////////////////////////
//                                                                             /
//                                                                             /
//  (C) Copyright 2026 Autodesk, Inc. All rights reserved.                     /
//                                                                             /
//                       ****  CONFIDENTIAL MATERIAL  ****                     /
//                                                                             /
//  The information contained herein is confidential, proprietary to           /
//  Autodesk, Inc., and considered a trade secret.  Use of this information    /
//  by anyone other than authorized employees of Autodesk, Inc. is granted     /
//  only under a written nondisclosure agreement, expressly prescribing        /
//  the scope and manner of such use.                                          /
//                                                                             /
////////////////////////////////////////////////////////////////////////////////

import React, {CSSProperties} from 'react';
import {FlexRowCentered} from "../CommonStyledComponents";
import Toggle from "@adsk/alloy-react-toggle";

const ToggleWithLabel = (
  {
    checked,
    checkedLabel,
    uncheckedLabel,
    style,
    disabled,
    onChange
  }: {
    checked: boolean,
    checkedLabel?: string | undefined,
    uncheckedLabel?: string | undefined,
    style?: CSSProperties,
    disabled?: boolean,
    onChange?: (checked: boolean) => void
  }) => {
  return (
    <FlexRowCentered style={style}>
      <Toggle checked={checked}
              disabled={disabled}
              onChange={onChange}
              style={{marginRight: '10px'}}/>
      <span>{checked ? checkedLabel ?? 'Yes' : uncheckedLabel ?? 'No'}</span>
    </FlexRowCentered>
  );
};

export default ToggleWithLabel;